import { MAX_UPLOAD_SIZE } from "@warda/library-ui/constants";
import itemsAddAndUploading from "../utils/itemsAddAndUploading";
import { MAX_UPLOAD } from "../../../constants/keys";
import itemsUpdate from "../utils/itemsUpdate";
import { UploadArea } from "../UploadArea";
export var ACTIONS;
(function (ACTIONS) {
    ACTIONS["RESET"] = "RESET";
    ACTIONS["SET_ITEMS"] = "SET_ITEMS";
    ACTIONS["ADD_ITEMS"] = "ADD_ITEMS";
    ACTIONS["MSG_CLOSE"] = "MSG_CLOSE";
    ACTIONS["MSG_OPEN"] = "MSG_OPEN";
    ACTIONS["EXPANDED"] = "EXPANDED";
})(ACTIONS || (ACTIONS = {}));
export const reducerInitState = {
    expanded: true,
    items: [],
    msgStopUpload: false,
};
export const reducer = (state, action) => {
    const newState = { ...state };
    switch (action.type) {
        case ACTIONS.ADD_ITEMS:
            newState.items = itemsAddAndUploading({
                area: UploadArea.sc,
                items: newState.items,
                filesToAdd: action.uploads,
                maxSize: MAX_UPLOAD_SIZE,
                numParallelUpload: MAX_UPLOAD,
            });
            return newState;
        case ACTIONS.SET_ITEMS:
            newState.items = itemsUpdate({
                area: UploadArea.sc,
                items: newState.items,
                item: action.item,
                numParallelUpload: MAX_UPLOAD,
            });
            return newState;
        case ACTIONS.EXPANDED:
            newState.expanded = !newState.expanded;
            return newState;
        case ACTIONS.MSG_OPEN:
            newState.msgStopUpload = true;
            return newState;
        case ACTIONS.MSG_CLOSE:
            newState.msgStopUpload = false;
            return newState;
        case ACTIONS.RESET:
            return reducerInitState;
        default:
            return newState;
    }
};
